import Swiper from 'swiper'
import { A11y, Autoplay, Pagination, EffectFade } from 'swiper/modules'

import { select } from '@js/util/select.js'
import { trackVisibility } from '@js/util/visibility.js'

select('.wpce-slider', sliderElement => {
  const options = JSON.parse(sliderElement.dataset.options)

  const swiper = new Swiper(sliderElement.querySelector('.swiper'), {
    modules: [A11y, Autoplay, Pagination, EffectFade],
    loop: true,
    allowTouchMove: false,
    speed: 650,
    effect: 'fade',

    a11y: {
      enabled: true,
    },

    autoplay: options.autoplay.enabled
      ? {
          disableOnInteraction: true,
          delay: options.autoplay.duration,
        }
      : false,

    pagination: options.pagination
      ? {
          el: sliderElement.querySelector('.swiper-pagination'),
          type: 'bullets',
          bulletElement: 'button',
          clickable: true,
        }
      : false,
  })

  // Start/stop autoplay based on slider visibility
  if (options.autoplay.enabled) {
    trackVisibility(sliderElement, isVisible => {
      if (isVisible) {
        swiper.autoplay.start()
      } else {
        swiper.autoplay.stop()
      }
    })
  }

  function stopAutoplay() {
    swiper.autoplay.stop()
  }

  // Stop autoplay when pagination bullets are clicked
  if (options.autoplay.enabled && options.pagination) {
    sliderElement.querySelector('.swiper-pagination').addEventListener('click', stopAutoplay)
  }

  return () => {
    sliderElement.querySelector('.swiper-pagination').removeEventListener('click', stopAutoplay)
    swiper.destroy()
  }
})
